import { makeStyles } from '@material-ui/core';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  modalCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: colors.white,
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    width: '100vw',
    height: 'calc(100vh - 64px)', // 64px == toolbar height
  },
  modalBody: {
    padding: '32px 24px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 24px 0 24px',
    alignItems: 'center',
    height: '67px',
    width: '100%',
  },
  modalHeaderItem: {
    display: 'flex',
    flexDirection: 'row',
  },
  headerTitle: {
    fontSize: fonts.sizes.xxlarge,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.18px',
    lineHeight: '24px',
    color: colors.gray,
    marginLeft: '20px',
  },
  headerIcon: {
    color: colors.gray,
    cursor: 'pointer',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '24px',
    },
    '& > :nth-child(2)': {
      paddingBottom: '24px',
    },
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
});

export default useStyles;
